export const baseState = state => state.base;